import { useState } from 'react';
import { Citation, openDocumentPdf } from '../../lib/api/research';

interface CitationListProps {
  citations: Citation[];
}

export default function CitationList({ citations }: CitationListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (citations.length === 0) return null;

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="mt-3">
      <div className="flex flex-wrap gap-1.5">
        {citations.map((citation, index) => (
          <button
            key={index}
            onClick={() => handleToggle(index)}
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors ${
              openIndex === index
                ? 'border-brand-300 bg-brand-50 text-brand-700 dark:border-brand-700 dark:bg-brand-500/15 dark:text-brand-400'
                : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700'
            }`}
          >
            <span>{citation.doc_type}</span>
            <svg
              className={`h-3 w-3 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        ))}
      </div>

      {openIndex !== null && citations[openIndex] && (
        <div className="mt-2 rounded-lg border border-brand-100 bg-brand-50 p-3 dark:border-brand-900 dark:bg-brand-500/10">
          {citations[openIndex].section_name && (
            <p className="mb-1 text-xs font-medium text-brand-700 dark:text-brand-400">
              {citations[openIndex].section_name}
            </p>
          )}
          <p className="text-xs text-gray-700 dark:text-gray-300 leading-relaxed">
            {citations[openIndex].excerpt}
          </p>
          {typeof citations[openIndex].doc_id === 'number' && (
            <button
              type="button"
              onClick={() => openDocumentPdf(citations[openIndex].doc_id as number)}
              className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-brand-600 hover:text-brand-700 hover:underline dark:text-brand-400 dark:hover:text-brand-300"
              title="Open the cited document in a new tab"
            >
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              Open document
            </button>
          )}
        </div>
      )}
    </div>
  );
}
